import { render, staticRenderFns } from "./SsoSetup.vue?vue&type=template&id=93c2b796&scoped=true"
import script from "./SsoSetup.vue?vue&type=script&lang=js"
export * from "./SsoSetup.vue?vue&type=script&lang=js"
import style0 from "./SsoSetup.vue?vue&type=style&index=0&id=93c2b796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c2b796",
  null
  
)

export default component.exports